import { render, staticRenderFns } from "./block-document-send-date.vue?vue&type=template&id=233faeed&scoped=true&lang=pug"
import script from "./block-document-send-date.vue?vue&type=script&lang=js"
export * from "./block-document-send-date.vue?vue&type=script&lang=js"
import style0 from "./block-document-send-date.vue?vue&type=style&index=0&id=233faeed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233faeed",
  null
  
)

export default component.exports